import { render, staticRenderFns } from "./GenerateW2.vue?vue&type=template&id=332ed66b&"
import script from "./GenerateW2.vue?vue&type=script&lang=js&"
export * from "./GenerateW2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports